// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__35Lhw","container":"dashboard_container__2Cz9N"};